import { render, staticRenderFns } from "./AccountOverview.vue?vue&type=template&id=685c679c&scoped=true&"
import script from "./AccountOverview.vue?vue&type=script&lang=js&"
export * from "./AccountOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685c679c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('685c679c')) {
      api.createRecord('685c679c', component.options)
    } else {
      api.reload('685c679c', component.options)
    }
    module.hot.accept("./AccountOverview.vue?vue&type=template&id=685c679c&scoped=true&", function () {
      api.rerender('685c679c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Affiliates/Dashboard/AccountOverview.vue"
export default component.exports